export const Storage = (storageType: "session" | "persist") => {
  const storage = storageType === "session" ? window.sessionStorage : window.localStorage;

  const get = <TRecords,>(key: string): TRecords | null => {
    const data = storage.getItem(key);
    if (data) return JSON.parse(data) as TRecords;
    return null;
  };

  const set = (key: string, value: any): void => {
    storage.setItem(key, JSON.stringify(value));
  };

  const remove = (key: string): void => {
    storage.removeItem(key);
  };

  const clear = (): void => {
    storage.clear();
  };

  return { get, set, remove, clear };
};
